import login from './login';
import logout from './logout';
import resetPassword from './reset-password';
import resetPasswordWithToken from './reset-password-with-token';
import forgotPassword from './forgot-password';
import adminAccountForm from './admin-account-form';
import adminAccountList from './admin-account-list';

export default {
  login,
  logout,
  resetPassword,
  resetPasswordWithToken,
  forgotPassword,
  adminAccountForm,
  adminAccountList,
};



// WEBPACK FOOTER //
// ./src/pages/auth/index.js